import { Smartphone } from "lucide-react";
import ViewMgtDevicePanel from "../ViewMgtDevicePanel";

export default function ViewMgtDeviceConfigPanicButtons({ configuration }: { deviceId?: string | null | undefined, device?: any | undefined | null, configuration?: any | undefined | null }) {
  
  return (
    <ViewMgtDevicePanel title="Panic Buttons" icon={<Smartphone size={16} />} fullWidth collapsible collapsed>
      <div className="grid grid-cols-1 gap-0">
        ...
      </div>
    </ViewMgtDevicePanel>
  );
}